// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RDMessageDialog_wrapper__3ShCo","message":"RDMessageDialog_message__3wiAr"};